<template>
  <div>
    <div class="container">
      <div v-if="isLoading" style="padding-top: 100px;" class="container has-text-centered opaque">
        <i class="fa fa-refresh fa-spin fa-4x"></i>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" class="container list-page-header">
        <div>
          <h3 class="title is-5">Certificate Requests</h3>
          <hr>
        </div>
      </div>
    </div>
    <div v-if="!isLoading" class="list-body container">
      <section>
        <div class="columns">
          <div class="column">
            <table class="table" style="width: 100%">
              <thead>
                <tr>
                  <th>Association</th>
                  <th>Request Date</th>
                  <th>Requester Name</th>
                  <th>Created By</th>
                  <th>Property Owner</th>
                  <th>Address</th>
                  <th>Loan Number</th>
                  <th>Cert. Holder</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(request, index) in requests" :key="request['.key']">
                  <td>
                    <router-link class="has-text-info" :to="'/requests/' + request.key">{{request.Association.Name}}</router-link>
                  </td>
                  <td>{{formatDate(request.Date)}}</td>
                  <td>{{request.RequesterName}}</td>
                  <td>{{request.RequesterEmail}}</td>
                  <td>{{request.PropertyOwnerName}}</td>
                  <td>{{request.PropertyAddress}}</td>
                  <td>{{request.LoanNumber}}</td>
                  <td>{{request.Association.Accord24.CertificateHolder}}</td>
                  <td style="width: 30px;">
                    <div class="is-pulled-right">
                      <div class="dropdown" :ref="'associationRow' + index">
                        <div class="dropdown-trigger">
                          <div class="icon is-small fa-button" v-on-clickaway="away" @click.stop="toggleActive('associationRow' + index)">
                            <i class="fa fa-ellipsis-v"></i>
                          </div>
                        </div>
                        <div class="dropdown-menu" id="dropdown-menu3" role="menu">
                          <div class="dropdown-content">
                            <a @click="openDeleteModal(index)" class="dropdown-item">
                              Delete Request
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <div class="modal" :class="{'is-active': showDeleteModal}" v-if="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="modal-close" @click="showDeleteModal = false"></div>
        <div class="box">
          <div class="content" style="margin-bottom: 50px;">
            <h5>Enter DELETE below to permanently delete request from {{requests[deleteIndex].RequesterEmail}} on {{formatDate(requests[deleteIndex].Date)}}
            </h5>
          </div>
          <div class="field" style="margin: -20px 0px 30px 0px;">
            <div class="control">
              <input class="input" type="text" v-model="deleteText" @input="checkDeleteText(deleteText)" placeholder="Enter DELETE">
            </div>
          </div>
          <button class="button is-success" @click="deleteRequest(deleteIndex)" :disabled="disableDeleteContinue">Continue</button>
          <button @click="showDeleteModal = false" class="button">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tenant from '@/tenant'
import moment from 'moment'
import { mixin as clickaway } from 'vue-clickaway'

export default {
  name: 'RequestsList',
  mixins: [clickaway],
  data: function () {
    return {
      isLoading: true,
      showDeleteModal: false,
      deleteIndex: 0,
      deleteText: '',
      disableDeleteContinue: true,
      openDropdownRef: {},
      requests: []
    }
  },
  methods: {
    initialize() {
      window.document.title = 'Certificate Requests'
      this.isLoading = true
      tenant.ref('requests').once('value').then((snapshot) => {
        this.requests = tenant.getArray(snapshot.val())
        this.requests.reverse()
        this.isLoading = false
      })
    },

    toggleActive(ref) {
      if (this.openDropdownRef.classList) {
        this.away()
        return
      }
      if (this.$refs[ref]) {
        this.openDropdownRef = this.$refs[ref][0]
        this.openDropdownRef.classList.add('is-active')
      }
    },
    openDeleteModal(index) {
      this.deleteIndex = index
      this.showDeleteModal = true
    },
    checkDeleteText(text) {
      if (text === 'DELETE') {
        this.disableDeleteContinue = false
      } else {
        this.disableDeleteContinue = true
      }
    },
    deleteRequest(index) {
      let key = this.requests[index].key
      tenant.ref('requests/' + key).remove().then(() => {
        this.deleteIndex = index
        this.showDeleteModal = false
        this.deleteText = ''
        this.disableDeleteContinue = true
        this.initialize()
      })
    },
    away() {
      if (this.openDropdownRef.classList) {
        this.openDropdownRef.classList.remove('is-active')
        this.openDropdownRef = {}
      }
    },
    formatDate(d) {
      if (d) {
        return moment(d).format('MM-DD-YYYY')
      }
      return null
    }
  },
  created: function () {
    tenant.initialize().then(() => {
      this.initialize()
    })
  }
}

</script>

<style scoped>
.request-title {
  margin-bottom: 20px;
  font-size: 24px;
}

.fa-button {
  /* margin: 8px 10px 0px 0px; */
  vertical-align: middle;
  font-size: 20px;
  cursor: pointer;
  opacity: 0.8;
}
</style>


// WEBPACK FOOTER //
// src/components/request/RequestsList.vue?95dba314